import React from 'react';
import { Link } from 'react-router-dom';

export type DashboardCardVariant = 'normal' | 'strong';

interface DashboardCardProps {
  title: string;
  subtitle: string;
  icon: string; // public配下へのパス /figma_asset/*.svg
  href?: string; // ある場合はリンク
  variant?: DashboardCardVariant; // strongでborder-4
  className?: string;
}

const baseClasses =
  'flex flex-1 flex-col items-center justify-center gap-[24px] bg-white rounded-[8px] p-[24px] min-w-[240px] h-[230px]';

export const DashboardCard: React.FC<DashboardCardProps> = ({
  title,
  subtitle,
  icon,
  href,
  variant = 'normal',
  className = '',
}) => {
  const border = variant === 'strong' ? 'border-4 border-black' : 'border border-black';
  const body = (
    <>
      <img src={icon} alt={title} className="w-[40px] h-[40px]" />
      <div className="flex flex-col items-center gap-[8px] w-full">
        <p className="text-[24px] font-semibold text-center text-[#1e1e1e] tracking-[-0.48px]">
          {title}
        </p>
        <p className="text-[16px] text-center text-[#1e1e1e]">{subtitle}</p>
      </div>
    </>
  );

  if (href) {
    const isInternal = href.startsWith('/');
    if (isInternal) {
      return (
        <Link to={href} className={`${baseClasses} ${border} ${className}`}>
          {body}
        </Link>
      );
    }
    return (
      <a href={href} className={`${baseClasses} ${border} ${className}`}>
        {body}
      </a>
    );
  }
  return (
    <div
      role="button"
      tabIndex={0}
      className={`${baseClasses} ${border} cursor-pointer ${className}`}
    >
      {' '}
      {body}{' '}
    </div>
  );
};
